import React, { useState, useEffect } from "react";
import { Row, Col, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import SifLogo from "../../assets/sif-logo.svg";
import UpjLogo from "../../assets/upj-logo.svg";
import ModalInstruksi from "../components/ModalInstruksi";
import "../styles/psikotesHeader.css";

function PsikotesHeader({ timer }) {
  const [showModal, setShowModal] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setHasScrolled(true);
      } else {
        setHasScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Row
      className={`sticky-header d-flex justify-content-between align-items-center p-3 mb-3 ${
        hasScrolled ? "header-shadow" : ""
      }`}
    >
      <Col
        md={4}
        xs={4}
        className="d-flex justify-content-start align-items-center"
      >
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip-info" className="custom-tooltip-header">Informasi Pengisian</Tooltip>}
        >
          <p className="information-logo mb-0">
            <i
              className="bi bi-info-circle-fill"
              onClick={() => setShowModal(true)}
              style={{ cursor: "pointer" }}
            ></i>
          </p>
        </OverlayTrigger>
      </Col>

      <Col
        md={4}
        xs={4}
        className="d-flex justify-content-center align-items-center"
      >
        <div className="timer-countdown mb-0">{timer}</div>
      </Col>

      <Col
        md={4}
        xs={4}
        className="d-flex justify-content-end align-items-center"
      >
        <div className="d-flex align-items-center justify-content-end gap-3">
          <Image src={UpjLogo} className="logo-header-psikotes" />
          <Image src={SifLogo} className="logo-header-psikotes" />
        </div>
      </Col>
      <ModalInstruksi show={showModal} onHide={() => setShowModal(false)} />
    </Row>
  );
}

export default PsikotesHeader;
